import { ChildrenOverviewResponse } from './ChildrenOverviewResponse';

export class OverviewResponse {
    Id: string;
    Identity: string;
    Name: string;
    ClusterName: string;
    CreatedAt: Date;
    AuthorizationKey: string;
    Organization: string;
    PaymentAccount: string;
    AccountType: string;
    BlipChatUrl: string;
    PhoneNumber: string;
    Children: Array<ChildrenOverviewResponse>;
    Status: string;
    ConnectionType: string;
    CanMigrateToCloudApi: boolean;
    MessageUrl: string;
    MessageHeaders: { [key: string]: string };
    NotificationUrl: string;
    NotificationHeaders: { [key: string]: string };
    RouterContext: string;
    MessageThroughput: string;
    NotificationThroughput: string;
    CommandThroughput: string;
}